import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import classnames from 'classnames';

const TutoriumInput = ({ field, form, label, type, placeholder, disabled }) => {
  const hasError = form.errors[field.name] && form.touched[field.name];

  const fieldClassName = classnames('tutorium-input', { 'is-invalid': hasError });

  return (
    <div className="field">
      {label && <label className="label">{label}</label>}
      <div className="control">
        <Field
          type={type || 'text'}
          {...field}
          className={fieldClassName}
          placeholder={placeholder || ''}
          disabled={disabled || false}
        />
      </div>
      {hasError && <p className="help is-danger">{form.errors[field.name]}</p>}
    </div>
  );
};

TutoriumInput.propTypes = {
  field: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
};

export default TutoriumInput;
